export const siteSettings = {
  name: "Trusty Trades Pro",
  link: "https://trustytradespro.com",
  email: "support@trustytradespro.com",
  appLink: "https://app.trustytradespro.com",
};
